import {
    isEmail,
    minDigitsLength,
    maxDigitsLength,
    isNumber,
    // isSumm,
} from '../utils/customValidators.js'
import {
    ERROR_MESSAGE,
    ERROR_FIELD,
    ERROR_MAIL,
    PHONE_LONG,
    PHONE_SHORT,
    ERROR_NUMBERS_ONLY,
    ACCEPTANCE_FALSE,
    // CAPTCHA_ERROR,
} from './../utils/messages'

import IMask from 'imask'

const trackYmGoal = (goal, extraParams = {}) => {
    try {
        if (!window.optiYm || typeof window.optiYm.reachGoal !== 'function') {
            return
        }

        window.optiYm.reachGoal(goal, extraParams)
        // eslint-disable-next-line no-empty
    } catch (error) {}
}

const attachYmFormStartTracking = (form) => {
    if (!form || form.dataset.ymStartBound === '1') {
        return
    }

    form.dataset.ymStartBound = '1'

    const handler = () => {
        trackYmGoal('hub2026_registration_start')
    }

    form.addEventListener('focusin', handler, { once: true })
    form.addEventListener('input', handler, { once: true })
}

// eslint-disable-next-line no-undef
const FORM_URL = data.ajax_url
// const captchaNum1 = Math.floor(Math.random() * 10) + 1
// const captchaNum2 = Math.floor(Math.random() * 10) + 1

const initPhoneMasks = (root = document) => {
    if (!root) {
        return
    }

    root.querySelectorAll("input[name='phone']").forEach((input) => {
        if (!input || input.dataset.imaskBound === '1') {
            return
        }

        input.dataset.imaskBound = '1'

        // eslint-disable-next-line new-cap
        IMask(input, {
            mask: '+{7} (000) 000-00-00',
            prepare: (appended, masked) => {
                if (appended === '8' && masked.value === '') {
                    return '7'
                }

                return appended
            },
        })
    })
}

// Generic function to handle modal opening with dynamic content
const openModal = (modal, contentSelector) => {
    const content = modal.querySelector(contentSelector)

    if (content) {
        modal.classList.add('is-opened', 'is-animated')
    }
}

const initRegistrationForm = (form) => {
    if (!form || form.dataset.registrationFormInited === '1') {
        return
    }

    form.dataset.registrationFormInited = '1'

    attachYmFormStartTracking(form)

    // const checkInput = form.querySelector('input[name="check"]')
    // if (checkInput) {
    //     checkInput.placeholder = `Антиспам: ${captchaNum1} + ${captchaNum2} = ?`
    // }

    attachInputValidationHandlers(form)
}

const bindRegistrationFormSubmit = (form) => {
    if (!form || form.dataset.registrationFormSubmitBound === '1') {
        return
    }

    form.dataset.registrationFormSubmitBound = '1'
    form.addEventListener('submit', handleFormSubmit)
}

const bindRegistrationForms = (root = document) => {
    if (!root) {
        return
    }

    initPhoneMasks(root)

    root.querySelectorAll('.main-form').forEach((form) => {
        initRegistrationForm(form)
        bindRegistrationFormSubmit(form)
    })
}

// Specific logic for handling form modals
const openFormModal = (modal) => {
    const form = modal?.querySelector?.('.main-form')

    if (form) {
        initRegistrationForm(form)
    }
}

// Event handler for modal open

const handleModalOpen = (event) => {
    const target = event.target.closest('.modal')

    if (target) {
        event.preventDefault()
        const modal = document.querySelector('.js-modal')

        if (!modal) {
            return
        }

        openModal(modal, '.opti-modal')
        openFormModal(modal)
    }
}

function highlight(element, msg = ERROR_FIELD) {
    unhighlight(element)
    const container = element.closest('.modal-form__group')

    if (container) {
        container.classList.add('is-error')
    }

    element.classList.add('error')

    const errorElement = document.createElement('small')
    errorElement.classList.add('error-message')
    errorElement.textContent = msg

    if (container) {
        container.appendChild(errorElement)
    }
}

function unhighlight(element) {
    const container = element.closest('.modal-form__group')

    if (container) {
        container.classList.remove('is-error')
        const errorElement = container.querySelector('.error-message')
        if (errorElement) {
            errorElement.remove()
        }

        // Добавляем класс is-valid, если поле валидно
        if (element.value.trim() && getErrorForInput(element) === null) {
            container.classList.add('is-valid')
        } else {
            container.classList.remove('is-valid')
        }
    }

    element.classList.remove('error')
}

function getErrorForInput(input) {
    if (input.name === 'comment') {
        return null
    }

    if (input.name === 'email') {
        if (!isEmail(input.value)) {
            return ERROR_MAIL
        }
    }

    if (input.name === 'phone') {
        if (!isNumber(input.value)) {
            return ERROR_NUMBERS_ONLY
        }

        if (!minDigitsLength(input.value, input, 6)) {
            return PHONE_SHORT
        }

        if (!maxDigitsLength(input.value, input, 11)) {
            return PHONE_LONG
        }
    }
    // if (input.name === 'check') {
    //     if (!isSumm(input.value, captchaNum1, captchaNum2)) {
    //         return CAPTCHA_ERROR
    //     }
    // }

    if (input.name === 'check_politic' && !input.checked) {
        return ACCEPTANCE_FALSE
    }

    if (!input.value.trim()) {
        return ERROR_FIELD
    }

    return null
}

function isValidForm(form) {
    let isValid = true
    const inputs = form.querySelectorAll('input')
    inputs.forEach((input) => {
        const isValidValue = isValidInput(input)

        if (!isValidValue) {
            isValid = false
        }
    })

    return isValid
}

function isValidInput(input) {
    const errorMsg = getErrorForInput(input)
    if (errorMsg) {
        highlight(input, errorMsg)

        return false
    }
    unhighlight(input)

    return true
}

const attachInputValidationHandlers = (form) => {
    const inputs = form.querySelectorAll('input')
    inputs.forEach((input) => {
        input.addEventListener('blur', () => {
            if (isValidInput(input)) {
                unhighlight(input)
            }
        })
    })
}

const validateForm = (form) => {
    const isValid = isValidForm(form)

    return isValid
}

const showSuccessPopup = () => {
    const successPopup = document.createElement('div')
    successPopup.classList.add('modal-block', 'modal-form__success-popup')

    successPopup.innerHTML = `
        <div class="container">
            <div class="modal-form">
                <div class="modal-close"></div>
                <div class="modal-form__heading">Спасибо за заявку на регистрацию!</div>
                <div class="modal-form__subtitle"><!--
                -->Мы свяжемся с&nbsp;Вами дополнительно по&nbsp;возможностям участия <!--
                -->в&nbsp;конференции Оптимакрос Хаб&nbsp;Москва&nbsp;2026<!--
                --></div>
                <div class="button modal-form__button-success button__primary">Закрыть</div>
            </div>
        </div>
    `

    document.body.appendChild(successPopup)

    setTimeout(() => {
        successPopup.classList.add('is-opened')
    }, 10)

    const closeSuccessPopup = (popup) => {
        popup.classList.remove('is-opened')
        setTimeout(() => popup.remove(), 300)
    }

    const closeButton = successPopup.querySelector('.modal-close')
    closeButton.addEventListener('click', () => closeSuccessPopup(successPopup))

    const successButton = successPopup.querySelector('.modal-form__button-success')
    successButton.addEventListener('click', () => closeSuccessPopup(successPopup))

    successPopup.addEventListener('click', (event) => {
        if (event.target === successPopup) {
            closeSuccessPopup(successPopup)
        }
    })
}

const handleFormSubmit = async (event) => {
    event.preventDefault()
    const form = event.target

    if (document.documentElement.classList.contains('is-sending')) {
        return
    }

    trackYmGoal('hub2026_registration_submit')

    if (!validateForm(form)) {
        trackYmGoal('hub2026_registration_error_validation')
        showErrorPopup()

        return
    }

    document.documentElement.classList.add('is-sending')

    const formData = new FormData(form)
    // formData.set('encoded_num1', btoa(captchaNum1.toString()))
    // formData.set('encoded_num2', btoa(captchaNum2.toString()))

    try {
        const response = await fetch(FORM_URL, {
            method: 'POST',
            body: formData,
        })

        document.documentElement.classList.remove('is-sending')

        const result = await response.json()

        if (result.success) {
            trackYmGoal('hub2026_registration_success')
            showSuccessPopup()
            form.reset()
            const inputs = form.querySelectorAll('input')
            inputs.forEach((input) => {
                unhighlight(input)
            })
        } else {
            // eslint-disable-next-line camelcase
            trackYmGoal('hub2026_registration_error_server', { error_type: 'response_not_success' })
            throw new Error('Response indicates failure')
        }

        handleFormResponse(result, form)
    } catch (error) {
        // eslint-disable-next-line camelcase
        trackYmGoal('hub2026_registration_error_server', { error_type: 'fetch_or_parse' })
        handleFormError(form)
    }
}

const handleFormResponse = (result, form) => {
    if (result.success) {
        // eslint-disable-next-line no-undef
        let message = data.messages.successMessage
        if (form.getAttribute('data-success-message') != '') {
            message = form.getAttribute('data-success-message')
        }
        form.reset()
        handleOutputMessage(form, true, message)
    } else {
        // eslint-disable-next-line no-undef
        handleOutputMessage(form, false, data.messages.errorMessage)
    }
}

const handleOutputMessage = (form, success, message) => {
    const root = form?.closest?.('.modal-form')
    const outputMessage = root ? root.querySelector('.form-row__output') : null

    if (!outputMessage) {
        return
    }

    if (success) {
        outputMessage.classList.remove('error')
        outputMessage.classList.add('success')
    } else {
        outputMessage.classList.remove('success')
        outputMessage.classList.add('error')
    }

    form.classList.add('hidden')
    outputMessage.innerHTML = message
    outputMessage.classList.remove('hidden')
    outputMessage.classList.add('visible')
}
const handleFormError = (form) => {
    document.documentElement.classList.remove('is-sending')

    const root = form?.closest?.('.modal-form')
    const outputMessage = root ? root.querySelector('.form-row__output') : null

    if (!outputMessage) {
        return
    }
    outputMessage.classList.remove('success')
    outputMessage.classList.add('error')
    outputMessage.textContent = ERROR_MESSAGE
}

const handleModalCloseButton = (event) => {
    const button = event.target.closest('.modal-close')
    if (button) {
        const modal = button.closest('.modal-block')
        if (modal) {
            modal.classList.remove('is-opened')
        }
    }
}

const handleModalCloseEscapeButton = () => {
    document.querySelectorAll('.modal-block').forEach((modal) => {
        modal.classList.remove('is-opened')
    })
}

const handleModalCloseBackground = (event) => {
    const modal = event.target
    if (
        (modal.classList.contains('js-modal') || modal.classList.contains('js-benefits-modal')) &&
        modal.classList.contains('is-opened')
    ) {
        modal.classList.remove('is-opened')
    }
}

const showErrorPopup = () => {
    const errorPopup = document.createElement('div')
    errorPopup.classList.add('modal-block', 'modal-form__error-popup')

    errorPopup.innerHTML = `
        <div class="container">
            <div class="modal-form">
                <div class="modal-close"></div>
                <div class="modal-form__heading">Не хватает информации</div>
                <div class="modal-form__subtitle">
                    Пожалуйста, проверьте, все ли Вы заполнили правильно.
                </div>
                <div class="button modal-form__button-error button__primary">Закрыть</div>
            </div>
        </div>
    `

    document.body.appendChild(errorPopup)

    setTimeout(() => {
        errorPopup.classList.add('is-opened')
    }, 10)

    const closeErrorPopup = (popup) => {
        popup.classList.remove('is-opened')
        setTimeout(() => popup.remove(), 300)
    }

    const closeButton = errorPopup.querySelector('.modal-close')
    closeButton.addEventListener('click', () => closeErrorPopup(errorPopup))

    const errorButton = errorPopup.querySelector('.modal-form__button-error')
    errorButton.addEventListener('click', () => closeErrorPopup(errorPopup))

    errorPopup.addEventListener('click', (event) => {
        if (event.target === errorPopup) {
            closeErrorPopup(errorPopup)
        }
    })
}

export {
    initPhoneMasks,
    initRegistrationForm,
    bindRegistrationForms,
    openModal,
    handleModalOpen,
    handleModalCloseButton,
    handleModalCloseEscapeButton,
    handleModalCloseBackground,
    handleFormSubmit,
    validateForm,
    isValidForm,
}
